import script from "./OfferBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferBadge.vue?vue&type=script&setup=true&lang=js"

import "./OfferBadge.vue?vue&type=style&index=0&id=5d06dff8&lang=css"

const __exports__ = script;

export default __exports__